/** An input for a Lux amount: typed as "12.50", reported as integer hundredths (1250); invalid text is kept on screen
 * and reported as undefined. */
import { useEffect, useState } from "react";
import { cx } from "./ui";
import { fmtLux, parseLux } from "../lib/lux";

export function LuxInput({ value, onChange, placeholder, disabled, ariaLabel }: {
  value: number | null | undefined;
  onChange: (hundredths: number | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  ariaLabel?: string;
}) {
  const [text, setText] = useState(value == null ? "" : fmtLux(value).replace(/,/g, ""));
  useEffect(() => {
    if (value != null && parseLux(text) !== value) setText(fmtLux(value).replace(/,/g, ""));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  const bad = text.trim() !== "" && parseLux(text) === undefined;
  return (
    <div className="input-affix">
      <input
        className={cx("input", bad && "is-invalid")}
        inputMode="decimal"
        aria-label={ariaLabel}
        placeholder={placeholder}
        disabled={disabled}
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          onChange(e.target.value.trim() === "" ? undefined : parseLux(e.target.value));
        }}
      />
      <span>Lux</span>
    </div>
  );
}
